import { flairs } from "./flairs";
import { generic } from "./generic";
import { keyboardMouse } from "./keyboard_mouse";
import { nintendoWii } from "./nintendo_wii";
import { playStationSeries } from "./play_station_series";
import { touch } from "./touch";
import { xboxSeries } from "./xbox_series";

export const input = {
  keyboardAndMouse: keyboardMouse,
  flairs,
  generic,

  touch,

  nintendoWii,
  playStationSeries,
  xboxSeries,
}